// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__VDa+f","dashboardContent":"Dashboard_dashboardContent__jeovE","lowerSection":"Dashboard_lowerSection__LuvJj"};